import { styled } from 'baseui';
export const ValidationRow = styled('div', () => ({
  marginBottom: '16px'
}));